import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_USER_MAPPING, APP_USER_MAPPING_IMPORT } from "./userMapping.constants";

const UserMappingList = Loadable(
  lazy(() =>
    import("./UserMappingList").then(({ UserMappingList }) => ({
      default: UserMappingList,
    }))
  )
);

const ImportUserMap = Loadable(
  lazy(() =>
    import("./ImportUserMap").then(({ ImportUserMap }) => ({
      default: ImportUserMap,
    }))
  )
);

const UserMapDetails = Loadable(
  lazy(() =>
    import("./UserMapDetails").then(({ UserMapDetails }) => ({
      default: UserMapDetails,
    }))
  )
);

export const UserMappingRoutes = [
  {
    path: `${APP_USER_MAPPING}/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <UserMappingList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_USER_MAPPING_IMPORT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ImportUserMap />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/user-mapping/get-user-map-details/document/:userMapCode`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <UserMapDetails />
      </AuthorizedRoute>
    ),
  },
];
